export default __webpack_public_path__ + "content/media/18.a69a8111.jpg";